import { render, staticRenderFns } from "./TabTitle.vue?vue&type=template&id=ac96ac24&scoped=true"
import script from "./TabTitle.vue?vue&type=script&lang=js"
export * from "./TabTitle.vue?vue&type=script&lang=js"
import style0 from "./TabTitle.vue?vue&type=style&index=0&id=ac96ac24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac96ac24",
  null
  
)

export default component.exports